module.exports = __webpack_public_path__ + "static/img/kf_cloud_00001.7ddb6a7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/kf_cloud_00001.jpg
// module id = 172
// module chunks = 1